module.exports = __webpack_public_path__ + "img/9788984074606.464e95c0.jpg";